import { apiCall } from "./base";

export const fetchCandidateCV = (hash) => apiCall(`/pdf/${hash}/cv`,{
  responseType: 'arraybuffer',
  headers:{
    'Content-Type':'application/pdf'
  }
});
